<mat-dialog-content>
  <div style="width: 100%">
    <canvas
      baseChart
      [data]="barChartData"
      [labels]="barChartLabels"
      [options]="barChartOptions"
      [legend]="barChartLegend"
      [type]="barChartType"
    >
    </canvas>
  </div>
</mat-dialog-content>
